#import "./fragments/DetailedIndicator.graphql"
#import "./fragments/SimplifiedIndicator.graphql"

query globalIndicators(
	$fromDate: LocalDate!
	$toDate: LocalDate!
	$fromComparativePeriod: LocalDate!
	$toComparativePeriod: LocalDate!
	$regionIds: [UUID!]
	$onlyStabilized: Boolean
	$granularity: Granularity
	$revenueModel: RevenueModel
	$comparison: DateRangeInput
	$dateComparison: InclusiveDateRangeInput
) {
	globalIndicators: globalIndicators(
		regionIds: $regionIds
		granularity: $granularity
		revenueModel: $revenueModel
	) {
		finance {
			bookingVolume(
				from: $fromDate
				to: $toDate
				mergeAndAcqIncluded: WITHOUT_MA
			) {
				...DetailedIndicator
				annualizedValue
			}
			bookingVolumeOnlyMergeAcquired: bookingVolume(
				from: $fromDate
				to: $toDate
				mergeAndAcqIncluded: ONLY_MA
			) {
				...DetailedIndicator
				annualizedValue
			}
			bookingVolumeWithMergeAcquired: bookingVolume(
				from: $fromDate
				to: $toDate
				mergeAndAcqIncluded: ALL
			) {
				...DetailedIndicator
				annualizedValue
			}
			bookingVolumeWithComparison(
			  from: $fromDate
        to: $toDate
        comparison: $dateComparison
        mergeAndAcqIncluded: WITHOUT_MA
      ) {
          source
          comparison
          difference
      }
			bookingValueAverage: averageBookingValue(from: $fromDate, to: $toDate)
			realizedRevenue(from: $fromDate, to: $toDate, mergeAndAcqIncluded: ALL) {
				...DetailedIndicator
				annualizedValue
			}
			financeChannelDistribution: channelDistribution(
				from: $fromDate
				to: $toDate
				mergeAndAcqIncluded: WITHOUT_MA
			) {
				channelName
				percentage
				total
			}
			otaRevenue(
				from: $fromDate
				to: $toDate
				mergeAndAcqIncluded: WITHOUT_MA
			) {
				bookingAmount
				percentage
				total
			}
			directRevenue(
				from: $fromDate
				to: $toDate
				mergeAndAcqIncluded: WITHOUT_MA
			) {
				bookingAmount
				percentage
				total
			}
		}
		sales {
			averageBookingLength: averageBookingLengthWithComparison(
				from: $fromDate
				to: $toDate
				comparison: $comparison
			) {
				source
				comparison
				difference
			}
			medianBookingLeadTime(from: $fromDate, to: $toDate) {
				...DetailedIndicator
			}
			repeatedBookings(from: $fromDate, to: $toDate) {
				...DetailedIndicator
			}
			occupancyRate(
				from: $fromDate
				to: $toDate
				onlyStabilized: $onlyStabilized
			) {
				...DetailedIndicator
			}
			weekendOccupancyRate(
				from: $fromDate
				to: $toDate
				onlyStabilized: $onlyStabilized
			) {
				...DetailedIndicator
			}
			weekdayOccupancyRate(
        from: $fromDate
        to: $toDate
        onlyStabilized: $onlyStabilized
      ) {
        ...DetailedIndicator
      }
			averageGroupSize: averageGroupSizeWithComparison(
				from: $fromDate
				to: $toDate
				comparison: $comparison
			) {
				source
				comparison
				difference
			}
			otaBookingsWithComparison(
				from: $fromDate
				to: $toDate
				comparison: $comparison
				mergeAndAcqIncluded: WITHOUT_MA
			) {
				difference
			}
			directBookingsWithComparison(
				from: $fromDate
				to: $toDate
				comparison: $comparison
				mergeAndAcqIncluded: WITHOUT_MA
			) {
				difference
			}
			cancelledBookings(from: $fromDate, to: $toDate) {
				...SimplifiedIndicator
			}
			returningGuests(from: $fromDate, to: $toDate) {
				...SimplifiedIndicator
			}
			channelDistribution(
				from: $fromDate
				to: $toDate
				mergeAndAcqIncluded: WITHOUT_MA
			) {
				channelName
				percentage
				total
			}
			bookings(from: $fromDate, to: $toDate) {
				...SimplifiedIndicator
			}
			repeats(from: $fromDate, to: $toDate)
		}
	}
	comparativePeriod: globalIndicators(
		regionIds: $regionIds
		granularity: $granularity
		revenueModel: $revenueModel
	) {
		finance {
			bookingVolume(
				from: $fromComparativePeriod
				to: $toComparativePeriod
				mergeAndAcqIncluded: WITHOUT_MA
			) {
				...DetailedIndicator
				annualizedValue
			}
			realizedRevenue(
				from: $fromComparativePeriod
				to: $toComparativePeriod
				mergeAndAcqIncluded: ALL
			) {
				...DetailedIndicator
				annualizedValue
			}
		}
		sales {
			averageBookingLength(
				from: $fromComparativePeriod
				to: $toComparativePeriod
			) {
				...DetailedIndicator
			}
			medianBookingLeadTime(
				from: $fromComparativePeriod
				to: $toComparativePeriod
			) {
				...DetailedIndicator
			}
			repeatedBookings(from: $fromComparativePeriod, to: $toComparativePeriod) {
				...DetailedIndicator
			}
			occupancyRate(from: $fromComparativePeriod, to: $toComparativePeriod, onlyStabilized: $onlyStabilized) {
				...DetailedIndicator
			}
			weekendOccupancyRate(
				from: $fromComparativePeriod
				to: $toComparativePeriod
				onlyStabilized: $onlyStabilized
			) {
				...DetailedIndicator
			}
			weekdayOccupancyRate(
			from: $fromComparativePeriod
        to: $toComparativePeriod
        onlyStabilized: $onlyStabilized
      ) {
        ...DetailedIndicator
      }
			averageGroupSize(from: $fromComparativePeriod, to: $toComparativePeriod) {
				...SimplifiedIndicator
			}
			cancelledBookings(
				from: $fromComparativePeriod
				to: $toComparativePeriod
			) {
				...SimplifiedIndicator
			}
			returningGuests(from: $fromComparativePeriod, to: $toComparativePeriod) {
				...SimplifiedIndicator
			}
			channelDistribution(
				from: $fromComparativePeriod
				to: $toComparativePeriod
				mergeAndAcqIncluded: WITHOUT_MA
			) {
				channelName
				percentage
			}
			bookings(from: $fromComparativePeriod, to: $toComparativePeriod) {
				...SimplifiedIndicator
			}
		}
	}
}
